import { render } from "./UpVote.vue?vue&type=template&id=6652647d"
import script from "./UpVote.vue?vue&type=script&lang=js"
export * from "./UpVote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thinley/dzg/feedback/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__